import { Platform } from "react-native"

/**
 * Le pointeur survole : une souris ou un pavé, au web. Un doigt (tablette, téléphone) et le natif : faux. Lu une fois,
 * au chargement — ce qui suit le survol (une bulle, une croix qui n'apparaît qu'au survol) a sinon sa forme au doigt.
 */
export function canHover(): boolean {
    if (Platform.OS !== "web") return false
    const matchMedia = (globalThis as { matchMedia?: (query: string) => { matches: boolean } }).matchMedia
    return matchMedia?.("(hover: hover)").matches === true
}
